<template>
    <button
        :disabled="disabled"
        class="DropdownButton"
        @click="toggleOpen"
    >
        <RPTooltip
            :status="status"
            :tooltip="statusMessage"
            class="DropdownButton__tooltip"
        />
        <div class="DropdownButton__container">
            <template v-if="showPlaceholder">
                {{ placeholder }}
            </template>
            <template v-else>
                <template v-if="multiple">
                    <DropdownTag
                        v-for="tag in selected"
                        :key="tag.value"
                        :value="tag.value"
                        :label="tag.label"
                        @deselect="val => $emit('deselect', val)"
                    />
                </template>
                <template v-else>
                    {{ selected.label }}
                </template>
            </template>
        </div>
        <div class="DropdownButton__arrow">
            <StreamlineIcon
                :fill="disabled ? grey100 : textGrey"
                :icon="open ? ArrowUp1 : ArrowDown1"
                :size="12"
                stroke="transparent"
            />
        </div>
    </button>
</template>

<script>
import has from 'lodash/has';
import StreamlineIcon from "@reviewpush/streamline-icons-vue";
import {ArrowUp1, ArrowDown1} from "@reviewpush/streamline-bold/lib/arrows-diagrams/Arrows";
import {grey100,textGrey} from 'style/_colors.scss';
import DropdownTag from './DropdownTag.vue';
import stat from 'status/index';

export default {
    name: "DropdownButton",
    components: {
        StreamlineIcon,
        DropdownTag
    },
    props: {
        open: {
            type: Boolean,
            required: true,
        },
        disabled: {
            type: Boolean,
            defatult: false,
        },
        placeholder: {
            type: String,
            default: 'Select Option...'
        },
        selected: {
            required: true,
            validator: prop => true
        },
        multiple: {
            type: Boolean,
            defatult: false,
        },
        status: {
            type: String,
            default: stat.STANDBY
        },
        statusMessage: {
            type: String,
            default: ''
        }
    },
    data(){
        return {
            ArrowUp1,
            ArrowDown1,
            grey100,
            textGrey,
        };
    },
    computed: {
        showPlaceholder(){
            return this.multiple
                ? this.selected.length < 1
                : !this.selected;
        },
        showIcon(){
            return !this.multiple && has(this.selected, 'icon');
        },
    },
    methods: {
        toggleOpen(){
            if(!this.disabled){
                this.$emit('toggle-open');
            }
        },
    }
};
</script>

<style lang="scss">
.DropdownButton {
    min-height: 2rem;
    width: 100%;
    border-radius: 4px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.25rem 0.5rem;

    &__tooltip{
        margin-right: 0.5rem;
    }
    &__container{
        flex-grow: 1;
        padding-right: 0.5rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: flex;
        flex-wrap: wrap;
    }
}
</style>